"use client";

import React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  author: "Marcus Thorne",
  quote: "FMC transformed our legacy systems into a high-velocity AI engine. Their strategic foresight is simply unmatched in the industry.",
  position: "Chief Technology Officer"
}, {
  author: "Elena Rodriguez",
  quote: "The digital transformation roadmap provided by Future Mind Consulting didn't just solve our problems; it redefined our market position.",
  position: "Managing Director"
}];
export default function VoicesOfSuccess() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223618" id="voices-of-success" className="bg-background text-foreground py-24 md:py-32 overflow-hidden relative" ref={ref}>
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-secondary/10 via-background to-background opacity-50 pointer-events-none" />
      
      <div className={`container mx-auto px-4 transition-all duration-1000 ease-out relative z-10 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="max-w-5xl mx-auto">
          <Carousel opts={{
          loop: true,
          align: "center"
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                  <div className="flex flex-col items-center justify-center text-center px-12 md:px-24 py-8">
                    <Quote className="size-12 md:size-16 text-primary/20 mb-8 rotate-180 shrink-0" />
                    
                    <blockquote className="mb-10">
                      <p className="font-default font-bold text-2xl md:text-4xl lg:text-5xl text-foreground leading-relaxed md:leading-snug tracking-tight">
                        "{testimonial.quote}"
                      </p>
                    </blockquote>
                    
                    <div className="flex flex-col items-center gap-3">
                      <cite className="font-default font-bold text-lg md:text-xl text-foreground not-italic">
                        {testimonial.author}
                      </cite>
                      <Badge variant="outline" className="bg-card/60 backdrop-blur-md border-border/50 text-primary font-mono uppercase tracking-widest text-[10px] md:text-xs px-3 py-1 rounded-md shadow-md">
                        {testimonial.position}
                      </Badge>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            <div className="hidden md:block">
              <CarouselPrevious className="bg-card/40 hover:bg-card border-border/50 text-foreground rounded-md transition-colors" />
              <CarouselNext className="bg-card/40 hover:bg-card border-border/50 text-foreground rounded-md transition-colors" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}